/**
 * Static business constants for La Petite Chef patisserie.
 * Single source of truth for contact info, location, and hours.
 * See open-questions.md QN-007 - confirm hours before launch.
 */
export const BUSINESS = {
    whatsappNumber: '+212615466820',
    whatsappLink: 'https://wa.me/212615466820',
    whatsappCatalog: 'https://www.whatsapp.com/catalog/212615466820/?app_absent=0',
    pickup: {
        address: '20 Av. Ain Hayani, Tanger 90000, Morocco',
        mapsLink: 'https://maps.app.goo.gl/6XWiV54usnb8rpaNA',
    },
    instagram: '@lapetitechefkamar',
    // Hours placeholder - QN-007: confirm before launch
    hours: {
        mon: '09:00-19:00',
        tue: '09:00-19:00',
        wed: '09:00-19:00',
        thu: '09:00-19:00',
        fri: '09:00-19:00',
        sat: '09:00-19:00',
        sun: 'closed',
    },
};
